import { useSearchParams } from "react-router"
import { z } from "zod"

import { updateSearchParams } from "@/helpers/url"

const searchOptionsSchema = z.object({
  search_query: z.string(),
  inactive_include: z.coerce.boolean(),
})

export type SearchOptions = z.infer<typeof searchOptionsSchema>

export function useCampaignSearchOptions() {
  const [params, setParams] = useSearchParams()

  const searchOptions = searchOptionsSchema.parse({
    search_query: params.get("search_query") || "",
    inactive_include: params.get("inactive_include") === "true",
  })

  const onChange =
    <K extends keyof SearchOptions>(key: K) =>
    (value: SearchOptions[K]) => {
      setParams((current) => {
        updateSearchParams(current, key, value.toString())

        return current
      })
    }

  return { searchOptions, onChange }
}
